// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { AbstractEnvironment } from "@biorec/common";
import { KeycloakOptions } from "keycloak-angular";

export class Environment extends AbstractEnvironment {

	static override readonly backendUrl = 'http://localhost:8001';
	
	static override readonly keycloakOptions = {
		config: {
			url: 'https://iam.biorec.org',
			realm: 'mikroskopisi-users',
			clientId: 'biorec-frontend-DEV',
		} as Keycloak.KeycloakConfig,
		initOptions: {
			onLoad: 'check-sso',
			silentCheckSsoRedirectUri: window.location.origin + '/assets/check-sso.html',
		},
		loadUserProfileAtStartUp: false,
		bearerExcludedUrls: []  
	} as KeycloakOptions;
}
